import { AgrLoginTypes, IETFLocales, SignupSigninPolicy } from '@next/core-lib/environment';

import { Environment } from './environment.model';

export { Environment } from './environment.model';

export const environment: Environment = {
  APPLICATION_NAME: 'Layer',
  API_BASE_URL: 'http://localhost:4200',
  CLIENT_ID: '8c830f86-9b7a-4d6b-a6bb-140b5ffcbd9b',
  REDIRECT_URL: 'http://localhost:4200',
  LOGIN_TYPE: AgrLoginTypes.redirect,
  SIGNUP_SIGNIN_POLICY: SignupSigninPolicy.All,
  PASSWORD_RESET_POLICY: 'B2C_1A_PasswordReset',
  AUTHORITY: 'https://agrifirmb2c.b2clogin.com/tfp/agrifirmb2c.onmicrosoft.com/',
  APPLICATION_KEY: 'Layer',
  AUTHORIZED_BY: {},
  APP_INSIGHTS_KEY: '85cd43e7-c453-4fae-af0f-f11c73380889',
  DEFAULT_LOCALE: IETFLocales.nl,
  LOCALES: [
    IETFLocales.nl,
    IETFLocales.en,
    IETFLocales['nl-BE'],
    IETFLocales['fr-BE'],
    IETFLocales.de,
  ],
  PRODUCTION: true,
  MY_OFFICE_URL: 'https://to-my.agrifirm.com',
  CUSTOMER_IN_LOCATION_SELECTOR: true,
  MSAL_LOGGING: false,
  NGRX_LOGGING: false,
  ERROR_PAGE_HOME_BUTTON: true,
  ERROR_PAGE_BACK_BUTTON: true,
  SHOP_URL: 'https://layer.agrifirm.com',
  IDENTIFICATION_TYPES_NL: ['ZCPNL1', 'ZEPEU1', 'ZMONL1', 'ZRONL1'],
  INSTANT_ORDER: true,
  DELIVERY_TIME_WINDOW_DISABLED: true,
  SHOW_CART_ICON: true,
  SHOW_DISABLED_LOCATION_BADGE: true,
  APIM_BASE_URL: 'https://gateway.api.agrifirm.com/external',
  SUBSCRIBE_TO_CART_EVENTS: true,
  IS_MY_PROSPECTS_HIDDEN: true,
  ARE_ORDER_BLOCKED_LOCATIONS_HIDDEN: true,
  IDENTIFICATION_WARNING_PERIOD: 'P21D',
  KUBE_CONTAINER_NAME: '',
  KUBE_NODE_NAME: '',
  KUBE_POD_NAME: '',
  KUBE_TEAM: '',
  USE_POULTRY_SERVICE: true,
  BREEDERS_ENABLED: false,
};
